import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { ChakraProvider } from '@chakra-ui/react'
import { I18nextProvider } from 'react-i18next'
import App from './App'
import { store, persistor } from './store/store'
import theme from './theme'
import i18n from './i18n'
import reportWebVitals from './reportWebVitals'
import { PersistGate } from 'redux-persist/integration/react'

const loadGoogleFonts = (): void => {
  const link = document.createElement('link')
  link.href = 'https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100..900;1,100..900&display=swap'
  link.rel = 'stylesheet'
  document.head.appendChild(link)
}

loadGoogleFonts()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <I18nextProvider i18n={i18n}>
          <ChakraProvider theme={theme}>
            <App />
          </ChakraProvider>
        </I18nextProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

export type { DatepickerConfigs, OnDateSelected } from './utils/commonTypes'
export type { CalendarPanelProps } from './components/calendarPanel'
export * from './utils/calanderUtils'
export { CalendarPanel } from './components/calendarPanel'
export * from './single'
export * from './range'
